import { productAction } from "../actionTypes";
import { Url } from "../../config/config";
import axios from "axios";
import { isLoggedIn } from "../../utils";

//------------------------------------------------PRODUCT-DETAILS-----------------------------------------------

export const productDetailsInitiate = () => ({
  type: productAction.PRODUCT_DETAILS_INITIATE,
});

export const productDetailsSuccess = (data) => ({
  type: productAction.PRODUCT_DETAILS_SUCCESS,
  payload: data,
});

export const productDetailsFailure = (data) => ({
  type: productAction.PRODUCT_DETAILS_FAILURE,
  payload: data,
});

export function getProductDetails(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(productDetailsInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/productDetails`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(productDetailsSuccess(data));
          } else {
            dispatch(productDetailsFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(productDetailsFailure(err));
          reject(err);
        }),
    );
  };
}

//------------------------------------------------PRODUCT-LIST-----------------------------------------------

export const ProductListActionInitiate = () => ({
  type: productAction.PRODUCT_LIST_INITIATE,
});

export const ProductListActionSuccess = (data) => ({
  type: productAction.PRODUCT_LIST_SUCCESS,
  payload: data,
});

export const ProductListActionFailure = (data) => ({
  type: productAction.PRODUCT_LIST_FAILURE,
  payload: data,
});

export function ProductListAction(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(ProductListActionInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/productList`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(ProductListActionSuccess(data));
          } else if (data.status === 505) {
            dispatch(ProductListActionSuccess(data));
          } else {
            dispatch(ProductListActionFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(ProductListActionFailure(err));
          reject(err);
        }),
    );
  };
}

//------------------------------------------------PRODUCT-REMOVE-----------------------------------------------

export const removeProductActionInitiate = () => ({
  type: productAction.REMOVE_PRODUCT_INITIATE,
});

export const removeProductActionSuccess = (data) => ({
  type: productAction.REMOVE_PRODUCT_SUCCESS,
  payload: data,
});

export const removeProductActionFailure = (data) => ({
  type: productAction.REMOVE_PRODUCT_FAILURE,
  payload: data,
});

export function removeProductAction(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(removeProductActionInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/removeProduct`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(removeProductActionSuccess(data));
          } else {
            dispatch(removeProductActionFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(removeProductActionFailure(err));
          reject(err);
        }),
    );
  };
}

//------------------------------------------------PRODUCT-STATUS-----------------------------------------------

export const productStatusActionInitiate = () => ({
  type: productAction.PRODUCT_STATUS_INITIATE,
});

export const productStatusActionSuccess = (data) => ({
  type: productAction.PRODUCT_STATUS_SUCCESS,
  payload: data,
});

export const productStatusActionFailure = (data) => ({
  type: productAction.PRODUCT_STATUS_FAILURE,
  payload: data,
});

export function productStatusAction(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(productStatusActionInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/changeProductStatus`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(productStatusActionSuccess(data));
          } else {
            dispatch(productStatusActionFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(productStatusActionFailure(err));
          reject(err);
        }),
    );
  };
}

export function toggleBranchProductAction(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/toggleBranchProduct`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        }),
    );
  };
}

export function setVariantStockAction(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/setVariantStock`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        }),
    );
  };
}

//------------------------------------------------PRODUCT-ADD-----------------------------------------------

export const productAddInitiate = () => ({
  type: productAction.PRODUCT_ADD_INITIATE,
});

export const productAddSuccess = (data) => ({
  type: productAction.PRODUCT_ADD_SUCCESS,
  payload: data,
});

export const productAddFailure = (data) => ({
  type: productAction.PRODUCT_ADD_FAILURE,
  payload: data,
});

export function getProductAdd(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(productAddInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/addProduct`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(productAddSuccess(data));
          } else {
            dispatch(productAddFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(productAddFailure(err));
          reject(err);
        }),
    );
  };
}

//------------------------------------------------PRODUCT-EDIT----------------------------------------------

export const productEditInitiate = () => ({
  type: productAction.PRODUCT_EDIT_INITIATE,
});

export const productEditSuccess = (data) => ({
  type: productAction.PRODUCT_EDIT_SUCCESS,
  payload: data,
});

export const productEditFailure = (data) => ({
  type: productAction.PRODUCT_EDIT_FAILURE,
  payload: data,
});

export function getProductEdit(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(productEditInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/updateProduct`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(productEditSuccess(data));
          } else {
            dispatch(productEditFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(productEditFailure(err));
          reject(err);
        }),
    );
  };
}

//------------------------------------------------STORE-Sub CATEGORY----------------------------------------------
export const subCategoryListInitiate = () => ({
  type: productAction.GET_SUB_CATEGORY_LIST_INITIATE,
});

export const subCategoryListSuccess = (data) => ({
  type: productAction.GET_SUB_CATEGORY_LIST_SUCCESS,
  payload: data,
});

export const subCategoryListFailure = (data) => ({
  type: productAction.GET_SUB_CATEGORY_LIST_FAILURE,
  payload: data,
});

export function subCategoryList(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(subCategoryListInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/storeSubCategoryDropDown`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(subCategoryListSuccess(data));
          } else {
            dispatch(subCategoryListFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(subCategoryListFailure(err));
          reject(err);
        }),
    );
  };
}
//------------------------------------------------STORE-Sub CATEGORY----------------------------------------------
export const requestSubCategoryInitiate = () => ({
  type: productAction.REQUEST_SUB_CATEGORY_INITIATE,
});

export const requestSubCategorySuccess = (data) => ({
  type: productAction.REQUEST_SUB_CATEGORY_SUCCESS,
  payload: data,
});

export const requestSubCategoryFailure = (data) => ({
  type: productAction.REQUEST_SUB_CATEGORY_FAILURE,
  payload: data,
});

export function requestSubCategory(payload) {
  const token = isLoggedIn("ownerLogin");
  return (dispatch) => {
    dispatch(requestSubCategoryInitiate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/requestSubcategory`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            requestSubCategorySuccess(data);
            resolve(data);
            // console.log("requestSubCategory", data);
          } else {
            requestSubCategoryFailure(data);
            reject(data);
          }
        })
        .catch((err) => {
          requestSubCategoryFailure(err);
          reject(err);
        });
    });
  };
}

// -----------------MY WORK ORDERRRRRRRRR----------------------------//
// -----------------MY WORK ORDERRRRRRRRR----------------------------//
// -----------------MY WORK ORDERRRRRRRRR----------------------------//
// -----------------MY WORK ORDERRRRRRRRR----------------------------//
// -----------------MY WORK ORDERRRRRRRRR----------------------------//
// -----------------MY WORK ORDERRRRRRRRR----------------------------//

export const orderListInitate = () => ({
  type: productAction.ORDER_LIST_INITIATE,
});

export const orderListSuccess = (data) => ({
  type: productAction.ORDER_LIST_SUCCESS,
  payload: data,
});

export const orderListFailure = (data) => ({
  type: productAction.ORDER_LIST_SUCCESS,
  payload: data,
});

export function orderListAction(payload) {
  const token = isLoggedIn("ownerLogin");
  return (dispatch) => {
    dispatch(orderListInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/orderList`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(orderListSuccess(data));
            resolve(data);
            // console.log(`orderList ---  ${data}`);
          } else {
            dispatch(orderListFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(orderListFailure(err));
          reject(err);
        });
    });
  };
}

export const orderDetailsInitate = () => ({
  type: productAction.ORDER_DETAILS_INITIATE,
});

export const orderDetailsSuccess = (data) => ({
  type: productAction.ORDER_DETAILS_SUCCESS,
  payload: data,
});

export const orderDetailsFailure = (data) => ({
  type: productAction.ORDER_DETAILS_FAILURE,
  payload: data,
});

export function orderDetailsAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(orderDetailsInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/orderDetails`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(orderDetailsSuccess(data));
            resolve(data);
          } else {
            dispatch(orderDetailsFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(orderDetailsFailure(err));
          reject(err);
        });
    });
  };
}

export const transactionListInitate = () => ({
  type: productAction.TRANSACTION_LIST_INITIATE,
});

export const transactionListSuccess = (data) => ({
  type: productAction.TRANSACTION_LIST_SUCCESS,
  payload: data,
});

export const transactionListFailure = (data) => ({
  type: productAction.TRANSACTION_LIST_FAILURE,
  payload: data,
});

export function transactionListAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(transactionListInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/transactionList`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(transactionListSuccess(data));
            resolve(data);
          } else {
            dispatch(orderDetailsFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(transactionListFailure(err));
          reject(err);
        });
    });
  };
}

export const transactionPaymentInitate = () => ({
  type: productAction.CHANGE_PAID_INITIATE,
});

export const transactionPaymentSuccess = (data) => ({
  type: productAction.CHANGE_PAID_SUCCESS,
  payload: data,
});

export const transactionPaymentFailure = (data) => ({
  type: productAction.CHANGE_PAID_FAILURE,
  payload: data,
});

export function transactionPaymentAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(transactionPaymentInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/changePaidStatus`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(transactionPaymentSuccess(data));
            resolve(data);
          } else {
            dispatch(transactionPaymentFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(transactionPaymentFailure(err));
          reject(err);
        });
    });
  };
}

export const markAsAllPaidInitate = () => ({
  type: productAction.CHANGE_PAID_INITIATE,
});

export const markAsAllPaidSuccess = (data) => ({
  type: productAction.CHANGE_PAID_SUCCESS,
  payload: data,
});

export const markAsAllPaidFailure = (data) => ({
  type: productAction.CHANGE_PAID_FAILURE,
  payload: data,
});

export function markAsAllPaidAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(markAsAllPaidInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/markAllPaid`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(markAsAllPaidSuccess(data));
            resolve(data);
          } else {
            dispatch(markAsAllPaidFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(markAsAllPaidFailure(err));
          reject(err);
        });
    });
  };
}

// -------------STORE--------------

export const storeTransactionListInitate = () => ({
  type: productAction.STORE_TRANSACTION_LIST_INITIATE,
});

export const storeTransactionListSuccess = (data) => ({
  type: productAction.STORE_TRANSACTION_LIST_SUCCESS,
  payload: data,
});

export const storeTransactionListFailure = (data) => ({
  type: productAction.STORE_TRANSACTION_LIST_FAILURE,
  payload: data,
});

export function storeTransactionListAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(storeTransactionListInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/storeTransactionList`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(storeTransactionListSuccess(data));
            resolve(data);
          } else {
            dispatch(storeTransactionListFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(storeTransactionListFailure(err));
          reject(err);
        });
    });
  };
}

export const storeTransactionPaymentInitate = () => ({
  type: productAction.STORE_CHANGE_PAID_INITIATE,
});

export const storeTransactionPaymentSuccess = (data) => ({
  type: productAction.STORE_CHANGE_PAID_SUCCESS,
  payload: data,
});

export const storeTransactionPaymentFailure = (data) => ({
  type: productAction.STORE_CHANGE_PAID_FAILURE,
  payload: data,
});

export function storeTransactionPaymentAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(storeTransactionPaymentInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/changePaidStatusStore`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(storeTransactionPaymentSuccess(data));
            resolve(data);
          } else {
            dispatch(storeTransactionPaymentFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(storeTransactionPaymentFailure(err));
          reject(err);
        });
    });
  };
}

export const storeMarkAsAllPaidInitate = () => ({
  type: productAction.STORE_MARK_ALL_PAID_INITIATE,
});

export const storeMarkAsAllPaidSuccess = (data) => ({
  type: productAction.SOTRE_MARK_ALL_PAID_SUCCESS,
  payload: data,
});

export const storeMarkAsAllPaidFailure = (data) => ({
  type: productAction.STORE_MARK_ALL_PAID_FAILURE,
  payload: data,
});

export function storeMarkAsAllPaidAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(storeMarkAsAllPaidInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}admin/markAllPaidStore`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(storeMarkAsAllPaidSuccess(data));
            resolve(data);
          } else {
            dispatch(storeMarkAsAllPaidFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(storeMarkAsAllPaidFailure(err));
          reject(err);
        });
    });
  };
}

export const notificationStatusInitate = () => ({
  type: productAction.NOTIFICATION_STATUS_INITIATE,
});

export const notificationStatusSuccess = (data) => ({
  type: productAction.NOTIFICATION_STATUS_SUCCESS,
  payload: data,
});

export const notificatioStatusFailure = (data) => ({
  type: productAction.NOTIFICATION_STATUS_FAILURE,
  payload: data,
});

export function notificatioStatusAction(payload) {
  const token = isLoggedIn("ownerLogin");
  // console.log(token)
  return (dispatch) => {
    dispatch(notificationStatusInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/changeOrderNotificationStatus`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data && data.status == 200) {
            dispatch(notificationStatusSuccess(data));
            resolve(data);
          } else {
            dispatch(notificatioStatusFailure(data));
            reject(data);
          }
        })
        .catch((err) => {
          dispatch(notificatioStatusFailure(err));
          reject(err);
        });
    });
  };
}
